import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { BASIC_PLAN, PRO_PLAN, getPlanPermissions } from '../config/planLimits';

const PlanContext = createContext();

export function usePlan() {
  return useContext(PlanContext);
}

const PLANS = {
  BASIC: 'BASIC',
  PRO: 'PRO'
};

export function PlanProvider({ children }) {
  const { currentUser } = useAuth();
  const [userPlan, setUserPlan] = useState(PLANS.BASIC);
  const [permissions, setPermissions] = useState(getPlanPermissions('BASIC'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setUserPlan(PLANS.BASIC);
      setPermissions(getPlanPermissions('BASIC'));
      setLoading(false);
      return;
    }

    // Usar onSnapshot para ouvir mudanças em tempo real
    const unsubscribe = onSnapshot(doc(db, 'users', currentUser.uid), (doc) => {
      if (doc.exists()) {
        const userData = doc.data();
        
        // Verifica o role do usuário
        const userRole = userData.role || 'user';
        
        // Debug: log para verificar o role
        console.log('PlanContext Debug:', { userRole, currentUser: currentUser.uid });
        
        // Define o plano baseado no role
        if (userRole === 'admin') {
          setPermissions({
            ...getPlanPermissions('PRO'),
            canAccessUserManagement: true
          });
          setUserPlan('PRO');
        } 
        else if (userRole === 'pro') {
          setPermissions(getPlanPermissions('PRO'));
          setUserPlan('PRO');
        } 
        else {
          setPermissions(getPlanPermissions('BASIC'));
          setUserPlan('BASIC');
        }
        
        // Debug: log para verificar o plano definido
        console.log('PlanContext Plan Set:', { userRole, userPlan: userRole === 'admin' || userRole === 'pro' ? 'PRO' : 'BASIC' });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  const updateUserPlan = (newPlan) => {
    setUserPlan(newPlan);
    setPermissions(getPlanPermissions(newPlan));
  };

  const value = {
    userPlan,
    permissions,
    loading,
    PLANS,
    updateUserPlan
  };

  return (
    <PlanContext.Provider value={value}>
      {!loading && children}
    </PlanContext.Provider>
  );
}

export default PlanProvider; 